import api from 'api'

const FETCH_REQUEST = 'realhub/admin/templateBuilder/templatePage/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/admin/templateBuilder/templatePage/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/admin/templateBuilder/templatePage/FETCH_FAILURE'

const initialState = {
  currentUsage: [],
  loading: false,
  errors: [],
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    currentUsage: payload.currentUsage,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

export function loadTemplatePageCurrentUsage(templatePageId, options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api(`/admin/template_pages/${templatePageId}/current_usage.json`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        dispatch(fetchSuccess({ currentUsage: json }))

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        currentUsage: action.currentUsage || [],
        loading: false,
        errors: [],
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.errors,
      })
    default:
      return state
  }
}
